module.exports = __webpack_public_path__ + "static/media/ucsd_logo.b24ca042.png";